/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerPatchMutationRequest,
  TelegramProductsModeratorControllerPatchMutationResponse,
  TelegramProductsModeratorControllerPatchPathParams,
  TelegramProductsModeratorControllerPatch401,
  TelegramProductsModeratorControllerPatch404,
} from '../types/TelegramProductsModeratorControllerPatch.ts';

function getTelegramProductsModeratorPatchUrl(id: TelegramProductsModeratorControllerPatchPathParams['id']) {
  const res = { method: 'PATCH', url: `/api/moderator/telegram/products/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/:id}
 */
export async function telegramProductsModeratorPatch(
  id: TelegramProductsModeratorControllerPatchPathParams['id'],
  data?: TelegramProductsModeratorControllerPatchMutationRequest,
  config: Partial<RequestConfig<TelegramProductsModeratorControllerPatchMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsModeratorControllerPatchMutationResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerPatch401 | TelegramProductsModeratorControllerPatch404>,
    TelegramProductsModeratorControllerPatchMutationRequest
  >({
    method: 'PATCH',
    url: getTelegramProductsModeratorPatchUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
